import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceRequestPaymentInputPaymentAmountComponent } from './service-request-payment-input-payment-amount.component';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '@lib/components';

@NgModule({
  declarations: [ServiceRequestPaymentInputPaymentAmountComponent],
  imports: [CommonModule, StaticMsgModule, AmountFormatModule, RouterModule, ButtonModule],
  exports: [ServiceRequestPaymentInputPaymentAmountComponent],
})
export class ServiceRequestPaymentInputPaymentAmountModule {}
